import { getAuth, signInWithPopup } from "firebase/auth";
import {
  createContext,
  createEffect,
  createSignal,
  For,
  Show,
  useContext,
} from "solid-js";
import { createActionStatus } from "../utility/createActionStatus";
import { useAuth } from "../utility/firebase";
import { authProviders } from "./authentication/authProviders";
import { Provider } from "./authentication/Provider";
import { Modal } from "./Modal";

const SignInContext = createContext();

export function SignInProvider(props) {
  const auth = getAuth();

  const [isSignInOpen, setIsSignInOpen] = createSignal(false);
  const [pendingProviderId, setPendingProviderId] = createSignal(null);
  const [status, error, run] = createActionStatus({ resetOnError: false });

  const handleSignIn = async (provider) => {
    setPendingProviderId(provider.id);
    await run(() => signInWithPopup(auth, provider.createProvider()));
    setPendingProviderId(null);
  };

  const user = useAuth(auth);

  createEffect(() => {
    if (user.data) {
      setIsSignInOpen(false);
    }
  });

  return (
    <SignInContext.Provider value={[isSignInOpen, setIsSignInOpen]}>
      {props.children}
      <Modal
        open={isSignInOpen()}
        onClose={() => setIsSignInOpen(false)}
        title="Sign in"
      >
        <p class="text-sm opacity-70 py-2">
          Choose an account to sign in with. You can link the others later.
        </p>
        <fieldset disabled={status() === "loading"}>
          <ul class="list">
            <For each={authProviders}>
              {(provider) => (
                <Provider
                  provider={provider}
                  button={() => (
                    <button
                      class="btn btn-sm btn-primary"
                      onClick={() => handleSignIn(provider)}
                    >
                      <Show when={pendingProviderId() === provider.id}>
                        <span class="loading loading-spinner loading-xs" />
                      </Show>
                      Sign In
                    </button>
                  )}
                />
              )}
            </For>
          </ul>
        </fieldset>
        <Show when={status() === "error"}>
          <p class="text-error text-sm pt-2">{error()}</p>
        </Show>
      </Modal>
    </SignInContext.Provider>
  );
}

export function useSignIn() {
  return useContext(SignInContext);
}
